import $ from 'jquery';

$(() => {
  const form = document.getElementById('new_user');
  if (!form) { return; }

  const $referralField = $("#user_self_reported_referral");
  const $otherField = $("#self_reported_referral_other");
  if ($referralField.length > 0) {
    $referralField.on('change', onReferralFieldChange);
  }
  onReferralFieldChange();

  function onReferralFieldChange(event) {
    var showOther = $referralField.val() === "other";
    if (showOther) {
      $otherField.removeClass('d-none');
      $otherField.attr('required', true);
    } else {
      $otherField.addClass('d-none');
      $otherField.attr('required', null);
    }
  }
});
